<template>
  <div>
    <h1 class="display-1 font-weight-black primary--text mb-2">
      Portal do Beneficiário
    </h1>
    <p class="subheading">Insira a nova senha para acessar o portal.</p>
    <v-form ref="form" v-model="valido">
      <v-text-field
        required
        data-cy="resetSenhaField"
        label="Senha"
        name="senha"
        type="password"
        v-model="data.senha"
        :rules="passwordRules"
      ></v-text-field>
      <v-text-field
        required
        data-cy="resetSenhaConfirmationField"
        label="Confirmação de Senha"
        name="senhaConfirmation"
        type="password"
        v-model="data.senhaConfirmation"
        :rules="passwordConfirmation"
      ></v-text-field>
    </v-form>
    <v-spacer></v-spacer>
    <v-layout align-center justify-space-between row fill-height>
      <v-btn
        flat
        color="grey darken-1"
        class="body-2 text-none mx-0 px-1"
        :to="{ name: 'acessar' }"
        >Já tenho o acesso</v-btn
      >
      <v-btn
        light
        class="mr-0"
        data-cy="recoverySubmitBtn"
        :color="highContrast ? 'white' : 'primary'"
        :disabled="!valido"
        @click="enviar"
        >Confirmar</v-btn
      >
    </v-layout>
    <p class="mt-4 subheading">
      Primeiro acesso?
      <v-btn
        flat
        color="grey darken-1"
        class="body-2 text-none mx-0 px-1"
        :to="{ name: 'primeiro-acesso' }"
        >Faça seu cadastro novo aqui</v-btn
      >
    </p>
  </div>
</template>

<script>
import auth from "./auth";
import { passwordValidation } from "@/utils/validation-rules";

export default {
  name: "RedefinirSenha",
  props: {
    highContrast: Boolean
  },
  data() {
    return {
      valido: false,
      data: {
        senha: "",
        senhaConfirmation: "",
        token: this.$route.query.token
      },
      passwordRules: [
        value => !!value || "A senha é obrigatória",
        value => passwordValidation(value)
      ],
      passwordConfirmation: [
        value => !!value || "A senha é obrigatória",
        value => passwordValidation(value),
        value =>
          value === this.data.senha ||
          "A senha nova a confirmação da senha nova devem ser iguais"
      ]
    };
  },
  methods: {
    enviar() {
      if (this.$refs.form.validate()) {
        auth
          .alterarSenha(this.data, this.$store, this.$router)
          .then(response => {
            this.setToast({
              message: response,
              type: "success",
              visible: true
            });
            this.$router.push({ name: "acessar" });
          })
          .catch(error => {
            this.setToast({ message: error, type: "error", visible: true });
          });
      }
    }
  }
};
</script>
